import React from 'react';
import { parseTriageSummary } from '../../utils/parseTriageSummary';

type QueueTriageSummaryProps = {
  /** Raw summary from `med.TeleAutoTriageConsult.Summary` (queue API). */
  summary?: string | null;
  /** Queue card uses light stage backgrounds vs dark default. */
  isLightBg: boolean;
  /** Section heading; default matches queue cards. */
  label?: string;
};

/**
 * Compact triage block for tele queue cards — bullet list for doctor/staff (same shaping as patient portal).
 */
export function QueueTriageSummary({ summary, isLightBg, label = 'Triage summary' }: QueueTriageSummaryProps) {
  const lines = parseTriageSummary(summary ?? '');
  if (lines.length === 0) return null;

  const labelColor = isLightBg ? '#475569' : '#94a3b8';
  const textColor = isLightBg ? '#1e293b' : '#e2e8f0';
  const markerColor = isLightBg ? '#0f766e' : '#5eead4';

  return (
    <div style={{ marginTop: 8, marginBottom: 10 }}>
      <div
        style={{
          fontSize: 10,
          fontWeight: 700,
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
          color: labelColor,
          marginBottom: 6,
        }}
      >
        {label}
      </div>
      <ul
        style={{
          margin: 0,
          paddingLeft: 18,
          fontSize: 12,
          lineHeight: 1.45,
          color: textColor,
          listStyleType: 'disc',
          listStylePosition: 'outside',
        }}
      >
        {lines.map((line, i) => (
          <li key={i} style={{ marginBottom: 3, paddingLeft: 2, color: markerColor }}>
            <span style={{ color: textColor }}>{line}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
